import { render, staticRenderFns } from "./prepayment.vue?vue&type=template&id=aff426a6&scoped=true&"
import script from "./prepayment.vue?vue&type=script&lang=js&"
export * from "./prepayment.vue?vue&type=script&lang=js&"
import style0 from "./prepayment.vue?vue&type=style&index=0&id=aff426a6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff426a6",
  null
  
)

export default component.exports